import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

// Per collegare il reducer - redux
import { connect } from 'react-redux';
// importa le actions del reducer
import * as actions from '../../reducers/actions/Auth'; //'./reducers/actions/Auth';

class SignOut extends Component {

    componentDidMount() {
        // console.log("[LOGOUT] - Logout didMount");
        this.props.onLogout();
    }

    render() {
        return (
            <Redirect to="/" />
        )
    }
}


const mapDispatchToProps = dispatch => {
    return {
        // onTryAutoSignUp: () => dispatch(actions.authCheckState()), // importa quindi la funzione di autoLogin dal redux action
        onLogout: () => dispatch(actions.logout()) // chiama la funzione logout dall reducer Auth
    };
};

export default connect(null, mapDispatchToProps)(SignOut);

